import { join } from 'light-component';
import { Icons } from 'zf-web-components/icons';
import { Box } from '../../../box';
import styles from '../style.module.less';
import { SelectStyleEnum } from '../types';
import type { ReactElement } from 'react';
import type { CharacterProps } from './types';

export function Character(props: CharacterProps): ReactElement | null {
  const { value = 0, index = 0 } = props;
  if (props.selectStyle == null || props.selectStyle === SelectStyleEnum.STAR) {
    const iconName = index + 1 <= value ? 'StarFilled' : 'StarOutlined';
    // 选中：StarFilled 未选中 StarOutlined
    return (<Icons name={iconName} className={styles.icon} />);
  }

  if (props.selectStyle === SelectStyleEnum.HEART) {
    // 选中：HeartFilled 未选中 HeartOutlined
    const iconName = index + 1 <= value ? 'HeartFilled' : 'HeartOutlined';
    return (<Icons name={iconName} className={styles.icon} />);
  }

  if (props.selectStyle === SelectStyleEnum.NUMBER_CIRCLE) {
    const className = index + 1 <= value ? styles.rateActiveText : styles.rateText;
    return (
      <Box className={join(styles.circle, className)}>
        {props.option[props.index ?? 0].value}
      </Box>
    );
  }

  if (props.selectStyle === SelectStyleEnum.NUMBER_SQUARE) {
    const className = index + 1 <= value ? styles.rateActiveText : styles.rateText;
    return (
      <Box className={join(styles.square, className)}>
        {props.option[props.index ?? 0].value}
      </Box>
    );
  }

  return null;
}
